import React from "react";
import {MyTextStyles} from "./styles";
import {MyTextProps} from "./props";

export const MyText = ({
                         children,
                         color = '#000',
                         align = 'left',
                         lineHeight = '100%',
                         size = 16,
                         weight = 400,
                         ...props
                       }: MyTextProps) => {

  return (
    <MyTextStyles {
                    ...{
                      ...props,
                      style: {
                        color: color,
                        lineHeight: lineHeight,
                        textAlign: align,
                        fontSize: size,
                        fontWeight: weight,
                        ...props.style
                      },
                    }
                  }>
      {children}
    </MyTextStyles>
  )
}